class ExternalVoucher {
  constructor(data) {
    this.id = data.id;
    this.benefit = data.benefit;
    this.code = data.code;
    this.name = data.name;
    this.redeemUrl = data.redemptionUrl;
  }
}
export default ExternalVoucher;
